<template>
  <svg
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    fill="none"
    :stroke="color"
    :stroke-width="size > 14 ? 2.8 : 3.2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </svg>
</template>

<script>
// The click-through's check mark: 14px white in selection circles, 16px teal in lists.
export default {
  name: 'CheckIcon',
  props: {
    size: {
      type: Number,
      default: 14,
    },
    color: {
      type: String,
      default: '#fff',
    },
  },
};
</script>
